import { Fragment } from 'react';
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider';
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types';
import QuoteOrderStatusBar, { QuoteOrderStatusBarNew, QuoteOrderStatusBarProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderStatusBar';
import QuoteOrderCreateNoPermissionButtons, { QuoteOrderCreateNoPermissionButtonsNew } from '../QuoteOrderCreateNoPermissionButtons';

type QuoteOrderCreateNoPermissionStepHeaderProps = & QuoteOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const QuoteOrderCreateNoPermissionStepHeaderDecider: React.FC<QuoteOrderCreateNoPermissionStepHeaderProps> = ({...rest}) => {
    return (
        <AppStyleDecider DefaultComponent={QuoteOrderCreateNoPermissionStepHeaderDefault} NewComponent={QuoteOrderCreateNoPermissionStepHeaderNew} {...rest} />
    )
}

const QuoteOrderCreateNoPermissionStepHeaderDefault: React.FC<QuoteOrderCreateNoPermissionStepHeaderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <QuoteOrderStatusBar {...rest} />
            <QuoteOrderCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const QuoteOrderCreateNoPermissionStepHeaderNew: React.FC<QuoteOrderCreateNoPermissionStepHeaderProps> = ({...rest}) => {
    return (
        <Fragment>
            <QuoteOrderStatusBarNew {...rest} />
            <QuoteOrderCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default QuoteOrderCreateNoPermissionStepHeaderDecider